import { useEffect } from 'react';
import { packagesModel } from 'entities/mine-package';
import { referrerModel } from 'entities/referrer';
import { useSaveRefCode } from 'features/tap2mine-referral';
import { useAppDispatch, useInterval, useIsAuthedAddress } from 'shared';
import { BuyPackageView } from 'widgets/buy-package';
import { Tap2MineReferralProgram } from 'widgets/referral-program';

import { Intro, PackagesList } from './ui';

export const Tap2Mine = () => {
  const dispatch = useAppDispatch();
  const isAuthedAddress = useIsAuthedAddress();

  useSaveRefCode();

  useInterval(() => dispatch(packagesModel.thunks.getPackages()), 15_000, { leading: false });

  useEffect(() => {
    if (!isAuthedAddress) {
      dispatch(referrerModel.actions.clearReferrerState());
    }
  }, [dispatch, isAuthedAddress]);

  useEffect(() => {
    dispatch(packagesModel.thunks.getInitialPackages());
  }, []);

  return (
    <>
      <Intro />
      <PackagesList />
      <BuyPackageView />
      {isAuthedAddress && <Tap2MineReferralProgram />}
    </>
  );
};
